import { render, staticRenderFns } from "./EmailIcon.vue?vue&type=template&id=7acf6328"
import script from "./EmailIcon.vue?vue&type=script&lang=js"
export * from "./EmailIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports